import { useState } from 'react';

import PropTypes from 'prop-types';

import { Alert, Typography, Button, Dialog } from '@mui/material';
import {
  BtnActionsDlgAsk, ContentSectionDialog,
} from '../assets/styles/admin-dashboard.dialog.styles';
import ProvidersService from '../../core/services/providers.service';

const ResendAgreementDialog = ({
  data,
  openDialog,
  setOpenDialog,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setErrror] = useState(false);

  const providerService = new ProvidersService();

  const handleOnClick = async (id) => {
    try {
      setLoading(true);
      await providerService.resendAgreementProvider(id)
      .then(() => {
        setOpenDialog(false);
        return onSuccess();
      }).finally(() => {
        setLoading(false);
      });
    } catch (error) {
      setErrror(true);
      console.log(error);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={openDialog}
        keepMounted
        onClose={handleDialogClose}
        PaperProps={{ sx: { padding: '16px' } }}
      >
        <ContentSectionDialog>
          <Typography>
            {`Are you sure you want to resend the ${data?.name} contract for signing?`}
          </Typography>
        </ContentSectionDialog>
        {error && <Alert severity="warning">Fail to send agreement, try again.</Alert>}
        <BtnActionsDlgAsk>
          <Button
            variant='outlined'
            color='secondary'
            onClick={() => {
              handleDialogClose();
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            variant='outlined'
            color='primary'
            onClick={() => {
              handleOnClick(data.agreementId);
            }}
          >
            Send
          </Button>
        </BtnActionsDlgAsk>
      </Dialog>
    </>
  );
};

export default ResendAgreementDialog;

ResendAgreementDialog.propTypes = {
  data: PropTypes.shape({
    agreementId: PropTypes.number,
    name: PropTypes.string,
  }),
  openDialog: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
};
